import { gql } from '@apollo/client';

import type { SignupChallengeStep } from '@jerry-serverless/enums/user_challenge';

import type { User } from './user.fragment';
import { USER_FRAGMENT } from './user.fragment';

/**
 * This query returns the current logged in user.
 */
export const VIEWER_QUERY = gql`
  query AppViewer {
    viewer {
      signupChallengeStep
      user {
        ${USER_FRAGMENT}
      }
    }
  }
`;

/**
 * This query returns the current MAL user.
 */
export const MAL_VIEWER_QUERY = gql`
  query AppViewer($malUserID: String!) {
    malViewer(malUserID: $malUserID) {
      user {
        ${USER_FRAGMENT}
      }
    }
  }
`;

export interface ViewerQueryData {
  viewer: {
    user: User | null;
    signupChallengeStep?: SignupChallengeStep | null;
  };
}

export interface MALViewerQueryData {
  malViewer: {
    user: User | null;
  };
}
